import AuthForm from "./AuthForm";
import { string } from "yup";
import { useTranslation } from "react-i18next";

export default function SignInForm({apiErrors, onSubmit}) {
  const {t} = useTranslation('translation', {keyPrefix: 'form'});

  const formFields = [
    {id: 'username', type: 'text', autoComplete: 'on'},
    {id: 'password', type: 'password', autoComplete: 'on'},
  ];

  const yup = {
    username: string().required(),
    password: string().required(),
  };
  
  return <AuthForm apiErrors={apiErrors} fields={formFields} onSubmit={onSubmit} onSubmitLabel={t('signIn')} yup={yup}/>;
}